import { Component } from '@angular/core';
import { GlobalService } from 'src/app/global.service';

@Component({
  selector: 'app-sell-out-details',
  templateUrl: './sell-out-details.component.html',
  styleUrls: ['./sell-out-details.component.css']
})
export class SellOutDetailsComponent {

  isOpen:boolean = false;
  isLoading:boolean = false;
  details:any = {};

  constructor(
    public globalservice: GlobalService
  ){}

  openModal(){ this.isOpen = true;}
  closeModal(){ this.isOpen = false; this.details = {};}
  
  setSellOutData(details:any){
    if(details){  
      this.details = details;
      this.isOpen = true;
    }else{
      this.isOpen = false;
    }
  }

}
